'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_navigation_LegacyIconButton_BaseIconButton = require('../LegacyIconButton/BaseIconButton.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const colorMappings = {
  "icon-primary": "icon-primary-dark",
  "icon-secondary": "icon-secondary-dark"
};
function DarkBackgroundIconButton(_a) {
  var { color = "icon-primary" } = _a, props = tslib_es6.__rest(_a, ["color"]);
  return React__default.default.createElement(components_navigation_LegacyIconButton_BaseIconButton.BaseIconButton, Object.assign({ color: colorMappings[color], size: "small" }, props));
}

exports.DarkBackgroundIconButton = DarkBackgroundIconButton;
//# sourceMappingURL=DarkBackgroundIconButton.cjs.js.map
